'use client';

import ForBrokersIcon from '@icons/ForBrokers.svg';
import PeosHeroImage from '@images/use-cases/PeosImage.webp';
import { Containers, Widgets } from '@components';
import { CompanySubnav } from '@/components/elements/CompanySubnav';
import RetainHighRiskClientsIcon from '@icons/HighRiskClients.svg';
import BrushIcon from '@icons/Brush.svg';
import {
    PEOS_USE_CASES_WHY_HOW_BLOCKS,
    PEOS_USE_CASES_WHY_HOW_SECTION_TITLE,
} from '@/utils/content/peosWhyHow';

export default function PeosPageUseCase() {
    return (
        <>
            <CompanySubnav section="use-cases" currentLabel="PEOs" />
            <Containers.Section
                el={
                    <Widgets.UseCasesHero
                        badge={{
                            iconSrc: ForBrokersIcon,
                            label: 'ICHRA Platform for PEOs',
                        }}
                        title="PEOs: Payroll Employment Organizations"
                        description="Predictable Benefits (PB) allows a Professional Employer Organization (PEO) to expand its addressable market, stabilize its revenue, and deepen client relationships without the risk of traditional group plan volatility."
                        secondaryDescription="Below are the key used cases for PEOs to offer ICHRAs using the PB platform to drive growth and retention."
                        image={{
                            src: PeosHeroImage,
                            alt: 'A smiling professional in a blue shirt at a desk in a bright office, writing in a notebook.',
                            priority: true,
                        }}
                        overlayCardsPositionClassName="bottom-[65%] right-3 md:bottom-[70%] md:right-4 lg:bottom-3 lg:right-3 lg:-translate-x-80"

                        overlayCards={[
                            {
                                title: 'Retain High-Risk Clients',
                                subtitle:
                                    'Keep clients even after renewal spikes',
                                iconSrc: RetainHighRiskClientsIcon,
                                className: 'w-full max-w-[320px] md:max-w-[320px] lg:max-w-[320px] shrink-0',
                            },
                            {
                                title: 'White-Label Experience',
                                subtitle: 'Your brand, not a third-party tool',
                                iconSrc: BrushIcon,
                                className: 'w-full max-w-[290px] md:max-w-[300px] lg:max-w-[300px] shrink-0',
                            },
                        ]}
                    />
                }
            />
            <Containers.Section el={<Widgets.HeroOvalDivider color="brand-50" />} />
            <Containers.Section
                el={
                    <Widgets.UseCasesWhyHow
                        sectionTitle={PEOS_USE_CASES_WHY_HOW_SECTION_TITLE}
                        blocks={PEOS_USE_CASES_WHY_HOW_BLOCKS}
                        pillNavMode="fromBlocks"
                    />
                }
            />
            <Containers.Section
                el={<Widgets.ExploreOtherUseCases excludeSlug="peos" />}
            />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
